import type { QuoteDocument, Tag } from 'paintscout'

// Return tag keys/names from quote, empty array if none, no deleted included by default
export const getTagKeys = (args: { quote: Partial<QuoteDocument>; includeDeleted?: boolean }): string[] => {
  const { quote, includeDeleted = false } = args
  const tags = quote?.tagDetails ?? quote?.tags ?? []
  return tags
    .map((tagDetails: string | Tag) => {
      if (typeof tagDetails === 'string') {
        return tagDetails
      }

      if (includeDeleted) {
        return tagDetails?.name
      } else if (!tagDetails?.deleted) {
        return tagDetails?.name
      } else {
        return null
      }
    })
    .filter(Boolean)
}
